const ru = {
  text: 'Открыть искажение в UX Core',
  tip: 'в новой вкладке',
};

export default ru;
